module.exports = __webpack_public_path__ + "img/ar_hash_next.7361ecbd.svg";